import PropTypes from 'prop-types';
import { useI18n } from '../../../../../context/I18nContext';
import './MessageStatusIndicator.css';

const MessageStatusIndicator = ({
  read = false,
  failed = false,
  pending = false,
  retrying = false,
  onClick = null,
}) => {
  const { t } = useI18n();

  const handleClick = (e) => {
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <span
      className="message-status-indicator"
      title={retrying
        ? t('MessageReadStatus.retrying')
        : failed
        ? t('MessageReadStatus.failed')
        : pending
          ? t('MessageReadStatus.pending')
          : (read ? t('MessageReadStatus.read') : t('MessageReadStatus.sent'))}
      onClick={handleClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {retrying && <i className="fa fa-refresh fa-spin retrying" />}
      {!retrying && failed && <i className="fa fa-exclamation-circle failed" />}
      {!retrying && !failed && pending && <i className="fa fa-clock-o pending" />}
      {!retrying && !failed && !pending && ((read) ? <i className="fa fa-check-circle read" /> : <i className="fa fa-check" />)}
    </span>
  );
};

MessageStatusIndicator.propTypes = {
  read: PropTypes.bool,
  failed: PropTypes.bool,
  pending: PropTypes.bool,
  retrying: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MessageStatusIndicator;
